import {ClientError} from 'mattermost-redux/client/client4';

import {ChannelFieldInvitationErrorCode} from './invite_members_form/channel_field_invitation_error_code';
import {ChannelFieldInvitationError} from './channel_field_invitation_error';
import {GeneralInvitationError} from './general_invitation_error';
import {GeneralInvitationErrorCode} from './invite_members_form/general_invitation_error_code';

const channelFieldInvitationErrorCodes: string[] = Object.values(ChannelFieldInvitationErrorCode);
const generalInvitationErrorCodes: string[] = Object.values(GeneralInvitationErrorCode);

export function handleRequestError(error: unknown) {
    if (error instanceof ClientError && error.server_error_id) {
        if (channelFieldInvitationErrorCodes.includes(error.server_error_id)) {
            return {
                channelError: new ChannelFieldInvitationError(error.server_error_id as ChannelFieldInvitationErrorCode),
                generalError: null,
            };
        }

        if (generalInvitationErrorCodes.includes(error.server_error_id)) {
            return {
                channelError: null,
                generalError: new GeneralInvitationError(error.server_error_id as GeneralInvitationErrorCode),
            };
        }
    }

    return {channelError: null, generalError: new GeneralInvitationError('unknown')};
}
